// Gift box add-on (theme setting "Gift box product"):
// - one per order: any extra quantity or duplicate line is reset to a single box
// - hidden from the cart recommendation carousel while it's in the cart
(function () {
  var config = window.giftBox;
  if (!config || !config.productId) return;

  config.inCart = false;

  var syncing = false;
  var syncAgain = false;
  var syncTimer = null;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function isGiftBoxSlide() {
    var $slide = window.jQuery(this);
    return $slide.is('.product-wrapper--gift-box') || $slide.find('.product-wrapper--gift-box').length > 0;
  }

  // Shows or hides the gift box slide. Returns true when the carousel changed.
  config.filterCarousel = function ($slider) {
    if ($slider.hasClass('slick-initialized')) {
      var filtered = $slider.data('giftBoxFiltered') === true;
      if (config.inCart === filtered) return false;
      if (config.inCart) {
        $slider.slick('slickFilter', function () {
          return !isGiftBoxSlide.call(this);
        });
      } else {
        $slider.slick('slickUnfilter');
      }
      $slider.data('giftBoxFiltered', config.inCart);
      return true;
    }

    // Slick only runs with 3+ products; leave larger lists to the slider init.
    var $slides = $slider.children('.product-wrapper');
    if ($slides.length > 2) return false;
    var $giftBox = $slides.filter('.product-wrapper--gift-box');
    if (!$giftBox.length || $giftBox.hasClass('is-hidden') === config.inCart) return false;
    $giftBox.toggleClass('is-hidden', config.inCart);
    return true;
  };

  function updateCarousel() {
    if (!window.jQuery) return;
    var changed = false;
    window.jQuery('.cart-feature_collection .feature_collection-wrapper').each(function () {
      if (config.filterCarousel(window.jQuery(this))) changed = true;
    });
    if (changed && typeof window.initializeCartRecommendationSlider === 'function') {
      window.initializeCartRecommendationSlider();
    }
  }

  function getSectionHTML(html, selector) {
    var element = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return element ? element.innerHTML : null;
  }

  // Re-renders the cart page and cart drawer after the quantity was corrected.
  function refreshCartViews() {
    var requests = ['cart-items', 'cart-drawer-items'].map(function (tagName) {
      var cartItems = document.querySelector(tagName);
      if (!cartItems || typeof cartItems.getSectionsToRender !== 'function') return null;
      var sections = cartItems.getSectionsToRender();
      var ids = sections.map(function (section) { return section.section; }).join(',');

      return fetch(root() + '?sections=' + ids)
        .then(function (response) { return response.json(); })
        .then(function (parsedSections) {
          sections.forEach(function (section) {
            var container = document.getElementById(section.id);
            if (!container || !parsedSections[section.section]) return;
            var target = container.querySelector(section.selector) || container;
            var html = getSectionHTML(parsedSections[section.section], section.selector);
            if (html !== null) target.innerHTML = html;
          });
        });
    });

    return Promise.all(requests);
  }

  function sync() {
    if (syncing) {
      syncAgain = true;
      return;
    }
    syncing = true;

    fetch(root() + 'cart.js')
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var lines = cart.items.filter(function (item) {
          return item.product_id === config.productId;
        });

        config.inCart = lines.length > 0;
        updateCarousel();

        var updates = {};
        var needsUpdate = false;
        lines.forEach(function (item, index) {
          var quantity = index === 0 ? 1 : 0;
          if (item.quantity !== quantity) {
            updates[item.key] = quantity;
            needsUpdate = true;
          }
        });
        if (!needsUpdate) return;

        return fetch(root() + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(refreshCartViews);
      })
      .catch(function (error) {
        console.error('Gift box sync failed:', error);
      })
      .finally(function () {
        syncing = false;
        if (syncAgain) {
          syncAgain = false;
          scheduleSync();
        }
      });
  }

  function scheduleSync() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(sync, 150);
  }

  config.sync = scheduleSync;

  function init() {
    // Every cart change re-renders the drawer or cart page items, so watch those for updates.
    var observer = new MutationObserver(function (mutations) {
      var cartChanged = mutations.some(function (mutation) {
        return !mutation.target.closest || !mutation.target.closest('.cart-feature_collection');
      });
      if (cartChanged) scheduleSync();
    });

    ['CartDrawer', 'main-cart-items'].forEach(function (id) {
      var element = document.getElementById(id);
      if (element) observer.observe(element, { childList: true, subtree: true });
    });

    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
